
import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Header from '../home/components/Header';
import Footer from '../home/components/Footer';

interface Product {
  id: number;
  name: string;
  category: string;
  categoryNL: string;
  description: string;
  descriptionNL: string;
  features: string[];
  featuresNL: string[];
  image: string;
  deployment: string;
  userRange: string;
  userRangeNL: string;
}

const products: Product[] = [
  {
    id: 1,
    name: 'Microsoft Dynamics 365',
    category: 'ERP & CRM',
    categoryNL: 'ERP & CRM',
    description:
      'Comprehensive business management solution combining ERP and CRM capabilities.',
    descriptionNL:
      'Uitgebreide bedrijfsbeheersoplossing die ERP- en CRM-mogelijkheden combineert.',
    features: ['Sales automation', 'Customer service', 'Finance management', 'Supply chain'],
    featuresNL: ['Verkoopautomatisering', 'Klantenservice', 'Financieel beheer', 'Supply chain'],
    image:
      'https://public.readdy.ai/ai/img_res/d55f31f778e324394d89325677a38311.jpg',
    deployment: 'Cloud',
    userRange: '10-1000+ users',
    userRangeNL: '10-1000+ gebruikers',
  },
  {
    id: 2,
    name: 'SAP Business One',
    category: 'ERP',
    categoryNL: 'ERP',
    description: 'Integrated ERP solution designed for small and medium-sized businesses.',
    descriptionNL:
      'Geïntegreerde ERP-oplossing ontworpen voor kleine en middelgrote bedrijven.',
    features: ['Financial management', 'Inventory control', 'Production planning', 'Reporting'],
    featuresNL: ['Financieel beheer', 'Voorraadbeheer', 'Productieplanning', 'Rapportage'],
    image:
      'https://readdy.ai/api/search-image?query=Enterprise%20resource%20planning%20software%20interface%20with%20financial%20charts%20and%20inventory%20management%20on%20clean%20white%20background%2C%20professional%20ERP%20system%2C%20modern%20design&width=400&height=300&seq=bs2&orientation=landscape',
    deployment: 'Hybrid',
    userRange: '10-500 users',
    userRangeNL: '10-500 gebruikers',
  },
  {
    id: 3,
    name: 'Salesforce',
    category: 'CRM',
    categoryNL: 'CRM',
    description: 'Leading cloud-based CRM platform for sales, service, and marketing.',
    descriptionNL:
      'Toonaangevend cloudgebaseerd CRM-platform voor verkoop, service en marketing.',
    features: ['Lead management', 'Sales forecasting', 'Marketing automation', 'Analytics'],
    featuresNL: ['Leadbeheer', 'Verkoopprognoses', 'Marketingautomatisering', 'Analyses'],
    image:
      'https://readdy.ai/api/search-image?query=Customer%20relationship%20management%20software%20dashboard%20with%20sales%20pipeline%20and%20customer%20data%20on%20clean%20white%20background%2C%20professional%20CRM%20interface%2C%20modern%20design&width=400&height=300&seq=bs3&orientation=landscape',
    deployment: 'Cloud',
    userRange: '5-Unlimited',
    userRangeNL: '5-Onbeperkt',
  },
  {
    id: 4,
    name: 'QuickBooks Enterprise',
    category: 'Accounting',
    categoryNL: 'Boekhouding',
    description: 'Advanced accounting software for growing businesses with complex needs.',
    descriptionNL:
      'Geavanceerde boekhoudsoftware voor groeiende bedrijven met complexe behoeften.',
    features: ['Advanced reporting', 'Inventory management', 'Payroll', 'Multi-user access'],
    featuresNL: [
      'Geavanceerde rapportage',
      'Voorraadbeheer',
      'Salarisadministratie',
      'Multi-user toegang',
    ],
    image:
      'https://readdy.ai/api/search-image?query=Accounting%20software%20interface%20with%20financial%20reports%20and%20invoice%20management%20on%20clean%20white%20background%2C%20professional%20bookkeeping%20application%2C%20modern%20design&width=400&height=300&seq=bs4&orientation=landscape',
    deployment: 'On-Premise',
    userRange: '1-30 users',
    userRangeNL: '1-30 gebruikers',
  },
  {
    id: 5,
    name: 'Sage Intacct',
    category: 'Accounting',
    categoryNL: 'Boekhouding',
    description: 'Cloud financial management software for growing organizations.',
    descriptionNL:
      'Cloud financieel beheersoftware voor groeiende organisaties.',
    features: ['Core financials', 'Multi-entity management', 'Revenue recognition', 'Dashboards'],
    featuresNL: ['Kernfinanciën', 'Multi-entiteitbeheer', 'Omzeterkenning', 'Dashboards'],
    image:
      'https://readdy.ai/api/search-image?query=Cloud%20financial%20management%20software%20dashboard%20with%20revenue%20charts%20and%20expense%20tracking%20on%20clean%20white%20background%2C%20professional%20finance%20application%2C%20modern%20interface&width=400&height=300&seq=bs5&orientation=landscape',
    deployment: 'Cloud',
    userRange: '10-500 users',
    userRangeNL: '10-500 gebruikers',
  },
  {
    id: 6,
    name: 'Oracle NetSuite',
    category: 'ERP',
    categoryNL: 'ERP',
    description: 'Unified cloud business management suite for enterprises.',
    descriptionNL: 'Geïntegreerde cloud bedrijfsbeheersuite voor ondernemingen.',
    features: ['Financial management', 'Order management', 'Inventory', 'E-commerce'],
    featuresNL: ['Financieel beheer', 'Orderbeheer', 'Voorraad', 'E-commerce'],
    image:
      'https://readdy.ai/api/search-image?query=Enterprise%20cloud%20business%20management%20software%20interface%20with%20order%20processing%20and%20inventory%20on%20clean%20white%20background%2C%20professional%20ERP%20platform%2C%20modern%20design&width=400&height=300&seq=bs6&orientation=landscape',
    deployment: 'Cloud',
    userRange: '50-Unlimited',
    userRangeNL: '50-Onbeperkt',
  },
  {
    id: 7,
    name: 'HubSpot CRM',
    category: 'CRM',
    categoryNL: 'CRM',
    description: 'Free CRM with marketing, sales, and service tools.',
    descriptionNL: 'Gratis CRM met marketing-, verkoop- en servicetools.',
    features: ['Contact management', 'Email tracking', 'Pipeline management', 'Reporting'],
    featuresNL: ['Contactbeheer', 'E-mailtracking', 'Pipelinebeheer', 'Rapportage'],
    image:
      'https://readdy.ai/api/search-image?query=Modern%20CRM%20software%20interface%20with%20contact%20management%20and%20sales%20pipeline%20on%20clean%20white%20background%2C%20professional%20customer%20management%20tool%2C%20sleek%20design&width=400&height=300&seq=bs7&orientation=landscape',
    deployment: 'Cloud',
    userRange: '1-Unlimited',
    userRangeNL: '1-Onbeperkt',
  },
  {
    id: 8,
    name: 'Zoho CRM',
    category: 'CRM',
    categoryNL: 'CRM',
    description: 'Affordable CRM solution for businesses of all sizes.',
    descriptionNL: 'Betaalbare CRM-oplossing voor bedrijven van elke omvang.',
    features: ['Sales automation', 'Workflow automation', 'Analytics', 'Mobile app'],
    featuresNL: ['Verkoopautomatisering', 'Workflowautomatisering', 'Analyses', 'Mobiele app'],
    image:
      'https://readdy.ai/api/search-image?query=Affordable%20CRM%20software%20dashboard%20with%20sales%20automation%20and%20workflow%20management%20on%20clean%20white%20background%2C%20professional%20business%20tool%2C%20modern%20interface&width=400&height=300&seq=bs8&orientation=landscape',
    deployment: 'Cloud',
    userRange: '1-Unlimited',
    userRangeNL: '1-Onbeperkt',
  },
  {
    id: 9,
    name: 'Xero',
    category: 'Accounting',
    categoryNL: 'Boekhouding',
    description: 'Beautiful accounting software for small businesses.',
    descriptionNL: 'Mooie boekhoudsoftware voor kleine bedrijven.',
    features: ['Invoicing', 'Bank reconciliation', 'Expense claims', 'Financial reporting'],
    featuresNL: [
      'Facturering',
      'Bankafstemming',
      'Onkostendeclaraties',
      'Financiële rapportage',
    ],
    image:
      'https://readdy.ai/api/search-image?query=Beautiful%20small%20business%20accounting%20software%20with%20invoicing%20and%20bank%20reconciliation%20on%20clean%20white%20background%2C%20professional%20bookkeeping%20interface%2C%20modern%20design&width=400&height=300&seq=bs9&orientation=landscape',
    deployment: 'Cloud',
    userRange: '1-50 users',
    userRangeNL: '1-50 gebruikers',
  },
  {
    id: 10,
    name: 'Monday.com',
    category: 'Project Management',
    categoryNL: 'Projectbeheer',
    description:
      'Work operating system for teams to run projects and workflows.',
    descriptionNL:
      'Werkbesturingssysteem voor teams om projecten en workflows uit te voeren.',
    features: ['Project tracking', 'Team collaboration', 'Automation', 'Integrations'],
    featuresNL: ['Projecttracking', 'Teamsamenwerking', 'Automatisering', 'Integraties'],
    image:
      'https://readdy.ai/api/search-image?query=Project%20management%20software%20interface%20with%20task%20boards%20and%20team%20collaboration%20on%20clean%20white%20background%2C%20professional%20workflow%20tool%2C%20modern%20design&width=400&height=300&seq=bs10&orientation=landscape',
    deployment: 'Cloud',
    userRange: '1-Unlimited',
    userRangeNL: '1-Onbeperkt',
  },
  {
    id: 11,
    name: 'Asana',
    category: 'Project Management',
    categoryNL: 'Projectbeheer',
    description: 'Project management tool to organize and plan team work.',
    descriptionNL: 'Projectbeheertool om teamwerk te organiseren en plannen.',
    features: ['Task management', 'Timeline view', 'Workload management', 'Reporting'],
    featuresNL: ['Taakbeheer', 'Tijdlijnweergave', 'Werkbelastingbeheer', 'Rapportage'],
    image:
      'https://readdy.ai/api/search-image?query=Task%20management%20software%20interface%20with%20timeline%20and%20workload%20views%20on%20clean%20white%20background%2C%20professional%20project%20planning%20tool%2C%20modern%20design&width=400&height=300&seq=bs11&orientation=landscape',
    deployment: 'Cloud',
    userRange: '1-Unlimited',
    userRangeNL: '1-Onbeperkt',
  },
  {
    id: 12,
    name: 'Slack',
    category: 'Communication',
    categoryNL: 'Communicatie',
    description: 'Business communication platform for team collaboration.',
    descriptionNL: 'Zakelijke communicatieplatform voor teamsamenwerking.',
    features: ['Channels', 'Direct messaging', 'File sharing', 'App integrations'],
    featuresNL: ['Kanalen', 'Directe berichten', 'Bestanden delen', 'App-integraties'],
    image:
      'https://readdy.ai/api/search-image?query=Business%20communication%20platform%20interface%20with%20chat%20channels%20and%20messaging%20on%20clean%20white%20background%2C%20professional%20collaboration%20tool%2C%20modern%20design&width=400&height=300&seq=bs12&orientation=landscape',
    deployment: 'Cloud',
    userRange: '1-Unlimited',
    userRangeNL: '1-Onbeperkt',
  },
];

const categoriesEN = [
  'ERP & CRM',
  'ERP',
  'CRM',
  'Accounting',
  'Project Management',
  'Communication',
];
const categoriesNL = [
  'ERP & CRM',
  'ERP',
  'CRM',
  'Boekhouding',
  'Projectbeheer',
  'Communicatie',
];
const categoryMap: Record<string, string> = {
  ERP: 'ERP',
  'ERP & CRM': 'ERP & CRM',
  CRM: 'CRM',
  Accounting: 'ERP & CRM', // fallback, not used
  Boekenhouding: 'Accounting',
  Boekhouding: 'Accounting',
  Projectbeheer: 'Project Management',
  Communicatie: 'Communication',
};

const deploymentsEN = ['Cloud', 'On-Premise', 'Hybrid'];
const deploymentsNL = ['Cloud', 'On-Premise', 'Hybride'];
const deploymentMap: Record<string, string> = {
  Cloud: 'Cloud',
  'On-Premise': 'On-Premise',
  Hybrid: 'Hybrid',
  Hybride: 'Hybrid',
};

export default function BusinessSoftwarePage() {
  const location = useLocation();
  const isNL = location.pathname.startsWith('/nl');
  const prefix = isNL ? '/nl' : '';

  const categories = isNL ? categoriesNL : categoriesEN;
  const deployments = isNL ? deploymentsNL : deploymentsEN;

  const [filteredProducts, setFilteredProducts] = useState<Product[]>(products);
  const [selectedCategories, setSelectedCategories] = useState<string[]>([]);
  const [selectedDeployment, setSelectedDeployment] = useState<string[]>([]);
  const [sortBy, setSortBy] = useState('name');

  useEffect(() => {
    try {
      let filtered = [...products];

      if (selectedCategories.length > 0) {
        const resolvedCategories = isNL
          ? selectedCategories.map((c) => categoryMap[c] ?? c)
          : selectedCategories;
        filtered = filtered.filter((p) => resolvedCategories.includes(p.category));
      }

      if (selectedDeployment.length > 0) {
        const resolvedDeployments = isNL
          ? selectedDeployment.map((d) => deploymentMap[d] ?? d)
          : selectedDeployment;
        filtered = filtered.filter((p) => resolvedDeployments.includes(p.deployment));
      }

      filtered.sort((a, b) => {
        if (sortBy === 'name') return a.name.localeCompare(b.name);
        if (sortBy === 'name-desc') return b.name.localeCompare(a.name);
        return 0;
      });

      setFilteredProducts(filtered);
    } catch (error) {
      console.error('Error while filtering products:', error);
      setFilteredProducts([]);
    }
  }, [selectedCategories, selectedDeployment, sortBy, isNL]);

  const handleCategoryChange = (category: string) => {
    setSelectedCategories((prev) =>
      prev.includes(category) ? prev.filter((c) => c !== category) : [...prev, category]
    );
  };

  const handleDeploymentChange = (deployment: string) => {
    setSelectedDeployment((prev) =>
      prev.includes(deployment) ? prev.filter((d) => d !== deployment) : [...prev, deployment]
    );
  };

  const clearFilters = () => {
    setSelectedCategories([]);
    setSelectedDeployment([]);
    setSortBy('name');
  };

  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-blue-600 via-indigo-600 to-purple-600 text-white py-24">
        <div className="absolute inset-0 bg-black/20"></div>
        <div className="container mx-auto px-6 relative z-10">
          <div className="max-w-3xl">
            <h1 className="text-5xl font-bold mb-6">
              {isNL ? 'Zakelijke Software Oplossingen' : 'Business Software Solutions'}
            </h1>
            <p className="text-xl mb-8 text-white/90">
              {isNL
                ? 'Transformeer uw bedrijfsprocessen met toonaangevende softwareoplossingen. Van ERP en CRM tot projectbeheer en communicatietools.'
                : 'Transform your business processes with industry-leading software solutions. From ERP and CRM to project management and communication tools.'}
            </p>
            <Link
              to={`${prefix}/contact`}
              className="inline-block bg-white text-indigo-600 px-8 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer"
            >
              {isNL ? 'Aan de Slag' : 'Get Started'}
            </Link>
          </div>
        </div>
      </section>

      {/* Products Section */}
      <section className="py-16">
        <div className="container mx-auto px-6">
          <div className="flex flex-col lg:flex-row gap-8">
            {/* Filters Sidebar */}
            <aside className="lg:w-64 flex-shrink-0">
              <div className="bg-gray-50 rounded-lg p-6 sticky top-24">
                <div className="flex items-center justify-between mb-6">
                  <h3 className="text-lg font-semibold text-gray-900">
                    {isNL ? 'Filters' : 'Filters'}
                  </h3>
                  <button
                    onClick={clearFilters}
                    className="text-sm text-indigo-600 hover:text-indigo-700 cursor-pointer whitespace-nowrap"
                  >
                    {isNL ? 'Alles Wissen' : 'Clear All'}
                  </button>
                </div>

                {/* Category Filter */}
                <div className="mb-6">
                  <h4 className="font-semibold text-gray-900 mb-3">
                    {isNL ? 'Categorie' : 'Category'}
                  </h4>
                  <div className="space-y-2">
                    {categories.map((category) => (
                      <label key={category} className="flex items-center cursor-pointer">
                        <input
                          type="checkbox"
                          checked={selectedCategories.includes(category)}
                          onChange={() => handleCategoryChange(category)}
                          className="w-4 h-4 text-indigo-600 rounded cursor-pointer"
                        />
                        <span className="ml-2 text-sm text-gray-700">{category}</span>
                      </label>
                    ))}
                  </div>
                </div>

                {/* Deployment Filter */}
                <div>
                  <h4 className="font-semibold text-gray-900 mb-3">
                    {isNL ? 'Implementatie' : 'Deployment'}
                  </h4>
                  <div className="space-y-2">
                    {deployments.map((deployment) => (
                      <label key={deployment} className="flex items-center cursor-pointer">
                        <input
                          type="checkbox"
                          checked={selectedDeployment.includes(deployment)}
                          onChange={() => handleDeploymentChange(deployment)}
                          className="w-4 h-4 text-indigo-600 rounded cursor-pointer"
                        />
                        <span className="ml-2 text-sm text-gray-700">{deployment}</span>
                      </label>
                    ))}
                  </div>
                </div>
              </div>
            </aside>

            {/* Products Grid */}
            <div className="flex-1">
              {/* Sort and Results */}
              <div className="flex items-center justify-between mb-6">
                <p className="text-gray-600">
                  {isNL
                    ? `${filteredProducts.length} van ${products.length} producten weergegeven`
                    : `Showing ${filteredProducts.length} of ${products.length} products`}
                </p>
                <select
                  value={sortBy}
                  onChange={(e) => setSortBy(e.target.value)}
                  className="px-4 py-2 border border-gray-300 rounded-lg text-sm cursor-pointer"
                >
                  <option value="name">{isNL ? 'Naam: A tot Z' : 'Name: A to Z'}</option>
                  <option value="name-desc">{isNL ? 'Naam: Z tot A' : 'Name: Z to A'}</option>
                </select>
              </div>

              {/* Products Grid */}
              <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
                {filteredProducts.map((product) => (
                  <div
                    key={product.id}
                    className="bg-white border border-gray-200 rounded-lg overflow-hidden hover:shadow-lg transition-shadow"
                  >
                    <div className="w-full h-48 bg-gray-100">
                      <img
                        src={product.image}
                        alt={product.name}
                        className="w-full h-full object-cover object-top"
                      />
                    </div>
                    <div className="p-6">
                      <div className="flex items-center gap-2 mb-2">
                        <span className="text-xs font-semibold text-indigo-600 bg-indigo-50 px-2 py-1 rounded whitespace-nowrap">
                          {isNL ? product.categoryNL : product.category}
                        </span>
                        <span className="text-xs text-gray-500">
                          {isNL ? product.userRangeNL : product.userRange}
                        </span>
                      </div>
                      <h3 className="text-lg font-semibold text-gray-900 mb-2">{product.name}</h3>
                      <p className="text-sm text-gray-600 mb-4">
                        {isNL ? product.descriptionNL : product.description}
                      </p>

                      <ul className="space-y-1 mb-4">
                        {(isNL ? product.featuresNL : product.features)
                          .slice(0, 3)
                          .map((feature, idx) => (
                            <li key={idx} className="text-sm text-gray-600 flex items-start">
                              <i className="ri-check-line text-green-600 mr-2 mt-0.5"></i>
                              {feature}
                            </li>
                          ))}
                      </ul>

                      <Link
                        to={`${prefix}/contact`}
                        className="block w-full bg-indigo-600 text-white text-center px-4 py-2 rounded-lg font-semibold hover:bg-indigo-700 transition-colors whitespace-nowrap cursor-pointer"
                      >
                        {isNL ? 'Offerte Aanvragen' : 'Request a Quote'}
                      </Link>
                    </div>
                  </div>
                ))}
              </div>

              {filteredProducts.length === 0 && (
                <div className="text-center py-12">
                  <i className="ri-inbox-line text-6xl text-gray-300 mb-4"></i>
                  <p className="text-gray-600">
                    {isNL
                      ? 'Geen producten gevonden die overeenkomen met uw filters.'
                      : 'No products found matching your filters.'}
                  </p>
                  <button
                    onClick={clearFilters}
                    className="mt-4 text-indigo-600 hover:text-indigo-700 font-semibold cursor-pointer whitespace-nowrap"
                  >
                    {isNL ? 'Filters Wissen' : 'Clear Filters'}
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
